import React from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classNames from "classnames";
import styled from "styled-components";
import { uid } from "react-uid";
import { useSelector, useDispatch } from "react-redux";

import { RootState, AppDispatch } from "../../../redux/store";
import {
    setIsActionsClicked,
    setIsEdited,
} from "../../../redux/slices/fidelitySlice";
import { useFidelityNavigationGuard } from "./FidelityNavigationGuardContext";

import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";

export type TabsType = {
    title: React.ReactNode;
    content: React.ReactNode;
    disabled?: boolean;
};

export type PropsType = { tabs: TabsType[] };

const StyleNavLink = styled(NavLink)`
    color: #323333;
    &:hover {
        color: #323333;
    }
`;

export function StyledTabs({ tabs }: PropsType) {
    const isEdited = useSelector((s: RootState) => s.fidelity.isEdited);
    const isActionsClicked = useSelector(
        (s: RootState) => s.fidelity.isActionsClicked
    );
    const dispatch = useDispatch<AppDispatch>();
    const { setOnConfirm } = useFidelityNavigationGuard();

    const [activeTab, setActiveTab] = React.useState<number>(0);

    function toggleActiveTab(tab: number): void {
        if (isEdited === true) {
            dispatch(setIsActionsClicked(!isActionsClicked));
            setOnConfirm(() => {
                dispatch(setIsEdited(false));
                if (activeTab !== tab) setActiveTab(tab);
            });
        } else {
            if (activeTab !== tab) setActiveTab(tab);
        }
    }

    return (
        <React.Fragment>
            <Nav tabs>
                {tabs.map((element: TabsType, index: number) => {
                    return (
                        <NavItem
                            className={classNames("nav-item-hover__clz", {
                                "nav-item-active__clz": activeTab === index,
                            })}
                            key={uid(element, index)}
                        >
                            <StyleNavLink
                                className={classNames(
                                    "disable-nav-link-hover",
                                    {
                                        "active nav-link-new-segment-active__clz active-tab__clz":
                                            activeTab === index,
                                    }
                                )}
                                onClick={() => {
                                    toggleActiveTab(index);
                                }}
                                disabled={element.disabled}
                            >
                                {element.title}
                            </StyleNavLink>
                        </NavItem>
                    );
                })}
            </Nav>
            <TabContent activeTab={activeTab} className="m-3">
                {tabs.map((element: TabsType, index: number) => {
                    return (
                        <TabPane tabId={index} key={uid(element, index)}>
                            {activeTab === index ? element.content : null}
                        </TabPane>
                    );
                })}
            </TabContent>
        </React.Fragment>
    );
}
